import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from "wix-ui-core/dist/es/src/hocs/Focusable/FocusableHOC";
import styles from './ListItemAction.st.css';
import Text from '../Text';
/** ListItemAction */

var ListItemActionComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ListItemActionComponent, _React$PureComponent);

  var _super = _createSuper(ListItemActionComponent);

  function ListItemActionComponent() {
    var _this;

    _classCallCheck(this, ListItemActionComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderText", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          size = _this$props.size,
          ellipsis = _this$props.ellipsis,
          tooltipModifiers = _this$props.tooltipModifiers;
      return /*#__PURE__*/React.createElement(Text, _extends({
        className: styles.text,
        weight: "normal",
        size: size,
        dataHook: "list-item-action-title",
        ellipsis: ellipsis,
        placement: "right"
      }, tooltipModifiers), title);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderPrefix", function () {
      var _this$props2 = _this.props,
          prefixIcon = _this$props2.prefixIcon,
          size = _this$props2.size;
      return /*#__PURE__*/React.cloneElement(prefixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: styles.prefixIcon,
        'data-hook': 'list-item-action-prefix-icon'
      });
    });

    return _this;
  }

  _createClass(ListItemActionComponent, [{
    key: "focus",
    value: function focus() {
      if (this.innerComponentRef) {
        this.innerComponentRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          dataHook = _this$props3.dataHook,
          disabled = _this$props3.disabled,
          skin = _this$props3.skin,
          prefixIcon = _this$props3.prefixIcon,
          onClick = _this$props3.onClick,
          focusableOnFocus = _this$props3.focusableOnFocus,
          focusableOnBlur = _this$props3.focusableOnBlur,
          Component = _this$props3.as,
          tabIndex = _this$props3.tabIndex,
          onKeyDown = _this$props3.onKeyDown,
          autoFocus = _this$props3.autoFocus,
          highlighted = _this$props3.highlighted;
      return /*#__PURE__*/React.createElement(Component, _extends({}, styles('root', {
        skin: skin,
        disabled: disabled,
        highlighted: highlighted
      }, this.props), {
        "data-skin": skin,
        "data-disabled": disabled,
        tabIndex: tabIndex,
        ref: function ref(_ref) {
          return _this2.innerComponentRef = _ref;
        },
        autoFocus: autoFocus,
        onFocus: focusableOnFocus,
        onBlur: focusableOnBlur,
        type: Component === 'button' ? 'button' : undefined,
        "data-hook": dataHook,
        onKeyDown: !disabled ? onKeyDown : undefined,
        onClick: !disabled ? onClick : undefined
      }), prefixIcon && this._renderPrefix(), this._renderText());
    }
  }]);

  return ListItemActionComponent;
}(React.PureComponent);

_defineProperty(ListItemActionComponent, "displayName", 'ListItemAction');

_defineProperty(ListItemActionComponent, "propTypes", {
  /** render as some other element */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),

  /** Data attribute for testing purposes */
  dataHook: PropTypes.string,

  /** Item theme (standard, dark, destructive) */
  skin: PropTypes.oneOf(['standard', 'dark', 'destructive']),

  /** Text Size (small, medium) */
  size: PropTypes.oneOf(['small', 'medium']),

  /** Prefix Icon */
  prefixIcon: PropTypes.node,

  /** When present, it specifies that a button should automatically get focus when the page loads. */
  autoFocus: PropTypes.bool,

  /** should the text get ellipsed with tooltip, or should it get broken into lines when it reaches the end of its container */
  ellipsis: PropTypes.bool,

  /** Title */
  title: PropTypes.string.isRequired,

  /** If true, the item is highlighted */
  highlighted: PropTypes.bool,

  /** Disabled */
  disabled: PropTypes.bool,

  /** Tooltip floating modifiers */
  tooltipModifiers: PropTypes.object,

  /** On Click */
  onClick: PropTypes.func
});

_defineProperty(ListItemActionComponent, "defaultProps", {
  as: 'button',
  skin: 'standard',
  size: 'medium',
  highlighted: false
});

export var ListItemAction = withFocusable(ListItemActionComponent);
export var listItemActionBuilder = function listItemActionBuilder(_ref2) {
  var title = _ref2.title,
      prefixIcon = _ref2.prefixIcon,
      onClick = _ref2.onClick,
      id = _ref2.id,
      disabled = _ref2.disabled,
      skin = _ref2.skin,
      size = _ref2.size,
      dataHook = _ref2.dataHook,
      as = _ref2.as,
      tabIndex = _ref2.tabIndex,
      autoFocus = _ref2.autoFocus,
      className = _ref2.className,
      ellipsis = _ref2.ellipsis;
  return {
    id: id,
    disabled: disabled,
    overrideStyle: true,
    value: function value(props) {
      return /*#__PURE__*/React.createElement(ListItemAction, _extends({}, props, {
        ellipsis: ellipsis,
        className: className,
        autoFocus: autoFocus,
        tabIndex: tabIndex,
        as: as,
        onClick: onClick,
        dataHook: dataHook,
        title: title,
        prefixIcon: prefixIcon,
        skin: skin,
        size: size,
        highlighted: props.hovered
      }));
    }
  };
};